import React,{useEffect} from 'react'
import './WhatDoesPrintoutDo.css'
import FeatureCard from '../../Common-Component/FeatureCard/FeatureCard'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import { getWhat_Media_Do } from '../../../features/aboutus/aboutusSlice';
import { useDispatch, useSelector } from "react-redux";
import parse from "html-react-parser";

const WhatDoesPrintoutDo = () => {

    const whatmediado = useSelector((state) => state.aboutus.addWhatMediaDo);
    const dispatch = useDispatch();
 
  
    useEffect(() => {
      dispatch(getWhat_Media_Do());
    }, [dispatch]);

    const data = [
        {
            title: "Lightning Fast Delivery",
            descn: "Reliable service with swift turnaround times.",
            img: "/assets/Images/AboutUs/WhatDoesDo/img1.png",
            bgcolour: "#FFD5EA"
        },

        {
            title: "Proven Trust",
            descn: "Over 15 years of delivering top-notch quality.",
            img: "/assets/Images/AboutUs/WhatDoesDo/img2.png",
            bgcolour: "#FFF1C2"
        },

        {
            title: "Effortless Ordering",
            descn: "No minimum quantity required, order as per your needs.",
            img: "/assets/Images/AboutUs/WhatDoesDo/img3.png",
            bgcolour: "#BFFBFF"
        },
    ]

    return (
        <section className='WhatDoesPrintoutDo'>
            <div className='row'>
                <div className='col-lg-3 col-md-3'>

                    <div className='left_side_part'>
                        <div className='tile_div'>
                            <p className='title'>What Does<br /> Print Out Media Do</p>
                        </div>
                        <div className='img_holder'>
                            <img src='/assets/Images/AboutUs/WhatDoesDo/question.png' className='question_img' />
                        </div>
                    </div>

                </div>

                <div className='col-lg-9 col-md-9'>
                    <div className='right_side_part'>

                        <Swiper
                            spaceBetween={15}
                            pagination={{
                                dynamicBullets: true,
                                clickable:true
                            }}
                            modules={[Pagination]}
                            autoplay={{ delay: 300 }}
                            className="mySwiper"
                            breakpoints={{
                                0: {
                                    slidesPerView: 1,

                                },
                                340: {
                                    slidesPerView: 1.2,
                                    spaceBetween: 5,
                                },
                                420: {
                                    slidesPerView: 1.4,
                                    spaceBetween: 5,
                                },
                                486: {
                                    slidesPerView: 2,
                                    spaceBetween: 5,
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                },
                                992: {
                                    slidesPerView: 2.4,
                                    spaceBetween: 10,
                                },
                                1200: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,
                                },
                                1400: {
                                    slidesPerView: 3,
                                    spaceBetween: 10,

                                },


                            }}
                        >

                            {whatmediado?.length > 0 && whatmediado?.map((item) => {
                                return (
                                    <SwiperSlide >
                                        <div className='coloured_card_main_div'>
                                            <FeatureCard title={item?.name} icon={process.env.REACT_APP_IMG_URL + item?.image} descn={item?.description} bgcolour={item?.bgcolour} />
                                        </div>
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>


                        {/* <div className='row'>
                            {data?.map((item) => {
                                return (
                                    <div className='col-4'>
                                        <div className='coloured_card_main_div'>
                                            <FeatureCard title={item?.title} icon={item?.img} descn={item?.descn} bgcolour={item?.bgcolour} />
                                        </div>
                                    </div>
                                )
                            })}
                        </div> */}


                    </div>
                </div>

            </div>

            <div className='description_holder'>
                <p className='descn'>
                    SM Pront Out Media is a leading retail chain that offers high-quality printing and personalized gifting services—all under one roof. Our goal is to make
                    printing seamless and hassle-free for both businesses and individuals. We work with you to create everything from business cards, letterheads, packaging, and
                    marketing brochures to exhibition banners. Our extensive library of templates makes it easy to design invitation cards, personalized gifts, and photo prints—all
                    at great prices. Our mission is two-fold: First, to bring a smile to our customers' faces by making their printing experience effortless. Second, to achieve
                    scalability and efficiency while maintaining top-tier quality in every service we provide.
                </p>
            </div>

        </section>
    )
}

export default WhatDoesPrintoutDo
